'use strict';

/**
 * The helpers exported in this file are used to calculate
 * the style details that will appear on the pdp.
 * Copy for the details titles is not determined in these helpers.
 * These methods return only the information that will
 * appear under a detail's title.
 */

const sharedHelpers = require('./detailsSharedLogic');

/**
 *
 * @param {object} item  - Bunsen Item model
 * @returns {string}     - option.name value of the first style_of attribute model of an item
 */
function getStyleOfLabel(item) {
    const styleOf = item.get('attributes.style_of');
    let styleOfModel;
    let styleOfLabel;

    if (styleOf) {
        styleOfModel = styleOf.first();
    }

    if (styleOfModel) {
        styleOfLabel = styleOfModel.get('option.name');
    }

    return styleOfLabel;
}

/**
 * Get the first style attribute model of an item, if the item's
 * style_of attribute is 'OF_THE_PERIOD' or it is a jewelry item
 *
 * @param {object} item          - Bunsen Item model
 * @returns {object} styleModel
 */
function getPeriodOfModel(item) {
    const style = item.get('attributes.style');
    const styleOfLabel = getStyleOfLabel(item);
    let styleOfIsValid = false;
    let styleOfLabelUppercase;
    let styleModel;

    if (style && styleOfLabel) {
        styleOfLabelUppercase = styleOfLabel.replace(/\s/g, '_').toUpperCase();
        // Todo put 'OF_THE_PERIOD' in a constant somewhere
        styleOfIsValid = styleOfLabelUppercase === 'OF_THE_PERIOD';
    }

    // Style on jewelry items should always be displayed as 'Of the period'
    if (style && item.get('vertical') === 'jewelry') {
        styleOfIsValid = true;
    }

    if (styleOfIsValid) {
        styleModel = style.first();
    }

    return styleModel;
}

/**
 * Get the first style attribute model of an item, if the item's
 * style_of attribute is 'IN_THE_STYLE_OF' or it is an art item
 *
 * @param {object} item - Bunsen Item model
 * @returns {object} styleModel
 */
function getStyleOfModel(item) {
    const style = item.get('attributes.style');
    const styleOfLabel = getStyleOfLabel(item);
    let styleOfIsValid = false;
    let styleModel;

    if (style && styleOfLabel && item.get('vertical') === 'furniture') {
        // Todo put IN_THE_STYLE_OF as a constant somewhere
        styleOfIsValid = styleOfLabel.replace(/\s/g, '_').toUpperCase() === 'IN_THE_STYLE_OF';
    }

    if (style && item.get('vertical') === 'art') {
        styleOfIsValid = true;
    }

    if (styleOfIsValid) {
        styleModel = style.first();
    }

    return styleModel;
}

module.exports = {
    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getPeriodOf(config) {
        const { item, links } = config;
        const periodOf = getPeriodOfModel(item);

        return sharedHelpers.addToContents({
            model: periodOf,
            modelKey: 'option.name',
            links,
            linkKey: 'periodOf',
        });
    },

    /**
     * See definition for addToContents in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getStyleOf(config) {
        const { item, links } = config;
        const styleOf = getStyleOfModel(item);

        return sharedHelpers.addToContents({
            model: styleOf,
            modelKey: 'option.name',
            links,
            linkKey: 'styleOf',
        });
    },

    /**
     * See definition for getSingleValueWithoutLink in detailsSharedLogic {@link newPdp/details/helpers/detailsSharedLogic}
     */
    getStyleOfLegacy(config) {
        return sharedHelpers.getSingleValueWithoutLink(config, 'classification.style.name');
    },
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/helpers/detailsStyles.es.js